import React, { useState } from 'react';
import { productService, contactService, memberService } from '../services/api';

const APITest = () => {
  const [testResults, setTestResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const addResult = (test, status, message) => {
    setTestResults(prev => [...prev, { test, status, message, timestamp: new Date().toLocaleTimeString() }]);
  };

  const runTests = async () => {
    setIsLoading(true);
    setTestResults([]);

    try {
      // Test 1: Get all products
      addResult('Get All Products', 'running', 'Testing...');
      const allProducts = await productService.getAllProducts();
      addResult('Get All Products', 'success', `Found ${allProducts.data.length} products`);

      // Test 2: Get chemical products
      addResult('Get Chemical Products', 'running', 'Testing...');
      const chemicalProducts = await productService.getProductsByCategory('chemical');
      addResult('Get Chemical Products', 'success', `Found ${chemicalProducts.data.length} chemical products`);

      // Test 3: Get mechanical products
      addResult('Get Mechanical Products', 'running', 'Testing...');
      const mechanicalProducts = await productService.getProductsByCategory('mechanical');
      addResult('Get Mechanical Products', 'success', `Found ${mechanicalProducts.data.length} mechanical products`);

      // Test 4: Get featured products
      addResult('Get Featured Products', 'running', 'Testing...');
      const featuredProducts = await productService.getFeaturedProducts();
      addResult('Get Featured Products', 'success', `Found ${featuredProducts.chemical?.length || 0} chemical and ${featuredProducts.mechanical?.length || 0} mechanical featured products`);

      // Test 5: Get all members
      addResult('Get All Members', 'running', 'Testing...');
      const allMembers = await memberService.getAllMembers();
      addResult('Get All Members', 'success', `Found ${allMembers.data.length} members`);

      // Test 6: Test contact form
      addResult('Contact Form Test', 'running', 'Testing...');
      await contactService.submitContactForm({
        name: 'API Test User',
        email: 'test@example.com',
        message: 'This is a test message from the React app.'
      });
      addResult('Contact Form Test', 'success', 'Contact form submitted successfully');

    } catch (error) {
      addResult('API Test', 'error', `Error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'success': return 'green';
      case 'error': return 'red';
      case 'running': return 'orange';
      default: return 'black';
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2>API Integration Test</h2>
      <p>This component tests all the API endpoints to ensure they're working correctly.</p>
      
      <button 
        onClick={runTests} 
        disabled={isLoading}
        style={{
          padding: '10px 20px',
          backgroundColor: '#004080',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: isLoading ? 'not-allowed' : 'pointer',
          marginBottom: '20px'
        }}
      >
        {isLoading ? 'Running Tests...' : 'Run API Tests'}
      </button>

      {testResults.length > 0 && (
        <div>
          <h3>Test Results:</h3>
          {testResults.map((result, index) => (
            <div 
              key={index} 
              style={{ 
                padding: '10px', 
                margin: '5px 0', 
                border: '1px solid #ccc', 
                borderRadius: '5px',
                backgroundColor: '#f9f9f9'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <strong style={{ color: getStatusColor(result.status) }}>
                  {result.test} - {result.status.toUpperCase()}
                </strong>
                <span style={{ fontSize: '0.8em', color: '#666' }}>{result.timestamp}</span>
              </div>
              <div style={{ marginTop: '5px', color: '#333' }}>{result.message}</div>
            </div>
          ))}
        </div>
      )}

      <div style={{ marginTop: '30px', padding: '15px', backgroundColor: '#e8f4fd', borderRadius: '5px' }}>
        <h4>Instructions:</h4>
        <ol>
          <li>Make sure your Django backend is running on <code>http://127.0.0.1:8000</code></li>
          <li>Click "Run API Tests" to test all endpoints</li>
          <li>Check the results to ensure all tests pass</li>
          <li>If any tests fail, check your backend server and API endpoints</li>
        </ol>
      </div>
    </div>
  );
};

export default APITest;
